// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\nh6[data-v-5bf149aa] {\n  color: var(--dark-green-100, #002e2a);\n  font-style: normal;\n  font-weight: 500;\n  line-height: 100%;\n}\n", ""]);
// Exports
module.exports = exports;
